<template>
  <div v-cloak>
    <Loader v-if="loader.data" />
    <div v-else class="container-fluid px-0">
      <Nav
        @show-contrast-view="toggleShowContrast"
        @show-regular-font-view="toggleRegularFontView"
        @show-middle-font-view="toggleMiddleFontView"
        @show-big-font-view="toggleBigFontView"
      />
      <div class="d-flex flex-column flex-lg-row">
        <div class="order-2 order-lg-1 col-lg-7 col-xl-8 px-0 bg-bee">
          <Content />
        </div>
        <div
          class="order-1 order-lg-1 col-lg-5 col-xl-4 px-0"
          style="z-index: 1000"
          id="order-form"
        >
          <Form />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Content from "./Content.vue";
import Nav from "./Nav.vue";
import Form from "./Form.vue";
import Loader from "./Loader.vue";

export default {
  name: "Page",
  data() {
    return {
      contrastView: false,
      fontRegularView: true,
      fontMiddleView: false,
      fontBigView: false,
      mainPage: true,
      showAdditionalNav: true,
    };
  },
  components: {
    Content,
    Nav,
    Form,
    Loader,
  },
  provide() {
    const appData = {
      showAdditionalNav: this.showAdditionalNav,
    };

    Object.defineProperty(appData, "showAdditionalNav", {
      get: () => this.showAdditionalNav,
    });

    return {
      appData,
    };
  },
  inject: ["loader"],
  methods: {
    toggleShowContrast: function () {
      this.contrastView = !this.contrastView;
    },
    toggleRegularFontView: function () {
      this.fontRegularView = !this.fontRegularView;
    },
    toggleMiddleFontView: function () {
      this.fontMiddleView = !this.fontMiddleView;
    },
    toggleBigFontView: function () {
      this.fontBigView = !this.fontBigView;
    },
    showAnimationFooterFn: function () {
      setTimeout(() => {
        this.showAnimationFooter = true;
      }, 500);
    },
    showAnimationOtherFn: function () {
      setTimeout(() => {
        this.showAnimationOther = true;
      }, 700);
    },
    scrollToTeaser() {
      let heightOfTeaser = document.getElementById("teaser")?.offsetTop || 2040;
      if (window.innerWidth < 1200) {
        window.scroll({
          top: heightOfTeaser + 425,
          left: 0,
          behavior: "smooth",
        });
      } else {
        if (heightOfTeaser) {
          window.scroll({
            top: heightOfTeaser || 2040,
            left: 0,
            behavior: "smooth",
          });
        }
      }
    },
    showAdditionalNavFn: function (val) {
      this.showAdditionalNav = val;
    },
    scrollToAdditionalNavFn: function () {
      setTimeout(this.scrollToTeaser(), 3000);
    },
  },
  created() {
    this.showAnimationFooterFn();
    this.showAnimationOtherFn();
    this.$root.$on("showAdditionalNavFn", (e) => {
      this.showAdditionalNavFn(e);
    });
    this.$root.$on("scrollToAdditionalNavFn", (e) => {
      this.scrollToAdditionalNavFn(e);
    });
  },

  watch: {
    contrastView: function () {
      const el = document.body;
      if (this.contrastView) {
        el.classList.add("body--contrast");
      } else {
        el.classList.remove("body--contrast");
      }
    },
    fontRegularView: function () {
      const el = document.getElementsByTagName("html")[0];
      el.classList.remove("body--middle-font");
      el.classList.remove("body--big-font");
    },
    fontMiddleView: function () {
      const el = document.getElementsByTagName("html")[0];

      el.classList.add("body--middle-font");
      el.classList.remove("body--big-font");
    },
    fontBigView: function () {
      const el = document.getElementsByTagName("html")[0];

      el.classList.remove("body--middle-font");
      el.classList.add("body--big-font");
    },
  },
};
</script>
